/**
 * Lightbox delete type.
 * @type {{LIGHTBOX_COLLECTION: string, LIGHTBOX_IMG: string}}
 */
export const REMOVE_ACTIVE_ITEM = {
    LIGHTBOX_COLLECTION: 'lightboxCollection',
    LIGHTBOX_IMG: 'lightboxImg',
};

/**
 * @type {string}
 * @description Custom attribute for setting the lightbox item type.
 */
export const LIGHTBOX_ITEM_TYPE_ATTRIBUTE = 'lightbox-item-type';

/**
 * @type {{
 *   ID: string,
 *   IMG_TEXT: string,
 *   IMG_SRC: string,
 *   IMG_UID: string,
 *   ELEMENT_TYPE: string,
 * }} LIGHTBOX_MODAL_ATTRIBUTES
 * @description Lightbox modal attributes.
 */
export const LIGHTBOX_MODAL_ATTRIBUTES = {
    ID: 'id',
    IMG_TEXT: 'img-text',
    IMG_SRC: 'img-src',
    IMG_UID: 'img-uid',
    ELEMENT_TYPE: 'element-type',
};

/**
 * @type {{
 *  ITEM: boolean,
 *  LIGHTBOX: boolean,
 *  REPORT: boolean,
 * }} - Element types to add to the lightbox.
 */
export const ELEMENT_TYPE_ADD_LIGHTBOX = {
    ITEM: 0,
    LIGHTBOX: 1,
    REPORT: 2,
};

/**
 * @type {number} - Max lightbox flex grow value.
 */
export const MAX_LIGHTBOX_FLEX_GROW_VALUE = 250;

/**
 * Event triggered when the user get the lightbox collections.
 * @type {string} - The event name.
 */
export const SEARCH_LIGHTBOX_RESULT_EVENT = 'search-lightbox-result';

/**
 * Event triggered when the user need to run the delete lightbox collection query only.
 * @type {string} - The event name.
 */
export const TRIGGER_DELETE_LIGHTBOX_COLLECTION_EVENT =
    'trigger-delete-lightbox-collection';

/**
 * Event triggered when the user need to run the delete lightbox element query only.
 * @type {string} - The event name.
 */
export const TRIGGER_DELETE_LIGHTBOX_ELEMENT_EVENT = 'trigger-delete-lightbox-element';

/**
 * Event triggered when the user need to run the update the lightbox title query only.
 * @type {string} - The event name.
 */
export const TRIGGER_UPDATE_LIGHTBOX_TITLE_EVENT = 'trigger-update-lightbox-title';

/**
 * Event triggered when the user close the lightbox modal.
 * @type {string} - The event name.
 */
export const TRIGGER_CLOSE_LIGHTBOX_MODAL_EVENT = 'trigger-close-lightbox-modal';

/**
 * Event triggered to update the default item.
 * @type {string} - The event name.
 */
export const TRIGGER_UPDATE_DEFAULT_ITEM_EVENT = 'trigger-update-default-item';

/**
 * Event triggered to update the default item.
 * @type {string} - The event name.
 */
export const TRIGGER_STAR_DEFAULT_ITEM_EVENT = 'trigger-star-default-item';

/**
 * Event triggered to update the lightbox name.
 * @type {string} - The event name.
 */
export const TRIGGER_UPDATE_LIGHTBOX_NAME_EVENT = 'trigger-update-lightbox-name';

/**
 * Event triggered to update the tooltip text of the lightbox icon.
 * @type {string} - The event name.
 */
export const TRIGGER_UPDATE_LIGHTBOX_ICON_TOOLTIP_EVENT =
    'trigger-update-lightbox-icon-tooltip';
